// BidZuu Constants and Configuration

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'https://inspector-api.preview.emergentagent.com';
export const API_URL = `${BACKEND_URL}/api`;

// PayPal Client ID — must match backend PAYPAL_CLIENT_ID + PAYPAL_MODE.
// Live client ID (matches backend live credentials).
export const PAYPAL_CLIENT_ID = process.env.REACT_APP_PAYPAL_CLIENT_ID || "AfVWsE85qPK2TuoTIZZ5cg_3OceG3rOGqEPq1plzyoFF99eApNK2JmjmmL_vU0sM-kB1lR1QNPsPpO1b";

// Logo URL
export const LOGO_URL = "https://customer-assets.emergentagent.com/job_sell-trade-hub/artifacts/d5iolvrq_Bidzuu%20logo%202026%201024.png";

// Currency conversion rates to USD (1 local = X USD) - Comprehensive list
export const CURRENCY_RATES = {
  // Major currencies
  "USD": 1.0, "EUR": 1.08, "GBP": 1.27, "JPY": 0.0067, "CHF": 1.13,
  "CAD": 0.74, "AUD": 0.65, "NZD": 0.61, "CNY": 0.14, "HKD": 0.13,
  // Asian currencies
  "INR": 0.012, "KRW": 0.00075, "SGD": 0.74, "TWD": 0.031, "THB": 0.029,
  "MYR": 0.22, "IDR": 0.000063, "PHP": 0.018, "VND": 0.00004, "PKR": 0.0036,
  "BDT": 0.0091, "LKR": 0.0031, "NPR": 0.0075, "MMK": 0.00048, "KHR": 0.00024,
  "LAK": 0.000048, "MNT": 0.00029, "BND": 0.74, "KZT": 0.0022, "UZS": 0.000079,
  // Middle East currencies
  "AED": 0.27, "SAR": 0.27, "QAR": 0.27, "KWD": 3.26, "BHD": 2.65,
  "OMR": 2.60, "JOD": 1.41, "ILS": 0.27, "TRY": 0.031, "IRR": 0.000024,
  "IQD": 0.00076, "SYP": 0.00004, "LBP": 0.000011, "YER": 0.004,
  // European currencies (non-EUR)
  "NOK": 0.094, "SEK": 0.095, "DKK": 0.14, "PLN": 0.25, "CZK": 0.043,
  "HUF": 0.0028, "RON": 0.22, "BGN": 0.55, "HRK": 0.14, "RSD": 0.0092,
  "UAH": 0.027, "RUB": 0.011, "BYN": 0.31, "MDL": 0.056, "ALL": 0.011,
  "MKD": 0.018, "BAM": 0.55, "ISK": 0.0073, "GEL": 0.37, "AMD": 0.0026,
  "AZN": 0.59,
  // African currencies
  "ZAR": 0.055, "NGN": 0.00065, "EGP": 0.032, "KES": 0.0077, "GHS": 0.083,
  "MAD": 0.10, "TND": 0.32, "DZD": 0.0074, "XOF": 0.0016, "XAF": 0.0016,
  "UGX": 0.00027, "TZS": 0.00039, "ETB": 0.018, "ZMW": 0.039, "BWP": 0.074,
  "MUR": 0.022, "NAD": 0.055, "MZN": 0.016, "AOA": 0.0012, "RWF": 0.00078,
  "SZL": 0.055, "LSL": 0.055, "MWK": 0.00059, "GMD": 0.015, "SCR": 0.074,
  // Americas currencies
  "MXN": 0.058, "BRL": 0.20, "ARS": 0.0012, "CLP": 0.0011, "COP": 0.00025,
  "PEN": 0.27, "UYU": 0.026, "PYG": 0.00014, "BOB": 0.14, "VES": 0.027,
  "DOP": 0.017, "GTQ": 0.13, "CRC": 0.0020, "PAB": 1.0, "HNL": 0.041,
  "NIO": 0.027, "JMD": 0.0065, "TTD": 0.15, "BBD": 0.50, "BSD": 1.0,
  "BZD": 0.50, "GYD": 0.0048, "SRD": 0.027, "HTG": 0.0076, "CUP": 0.042,
  "AWG": 0.56, "ANG": 0.56, "XCD": 0.37, "KYD": 1.22, "BMD": 1.0,
  // Oceania currencies
  "FJD": 0.45, "PGK": 0.26, "WST": 0.37, "TOP": 0.43, "VUV": 0.0084,
  "SBD": 0.12, "XPF": 0.0091
};

// Currency symbols for all supported currencies
export const CURRENCY_SYMBOLS = {
  // Major currencies
  "USD": "$", "EUR": "€", "GBP": "£", "JPY": "¥", "CHF": "Fr",
  "CAD": "C$", "AUD": "A$", "NZD": "NZ$", "CNY": "¥", "HKD": "HK$",
  // Asian currencies
  "INR": "₹", "KRW": "₩", "SGD": "S$", "TWD": "NT$", "THB": "฿",
  "MYR": "RM", "IDR": "Rp", "PHP": "₱", "VND": "₫", "PKR": "Rs",
  "BDT": "৳", "LKR": "Rs", "NPR": "Rs", "MMK": "K", "KHR": "៛",
  "LAK": "₭", "MNT": "₮", "BND": "B$", "KZT": "₸", "UZS": "сўм",
  // Middle East currencies
  "AED": "د.إ", "SAR": "﷼", "QAR": "ر.ق", "KWD": "د.ك", "BHD": "د.ب",
  "OMR": "ر.ع.", "JOD": "د.ا", "ILS": "₪", "TRY": "₺", "IRR": "﷼",
  "IQD": "ع.د", "SYP": "£S", "LBP": "ل.ل", "YER": "﷼",
  // European currencies (non-EUR)
  "NOK": "kr", "SEK": "kr", "DKK": "kr", "PLN": "zł", "CZK": "Kč",
  "HUF": "Ft", "RON": "lei", "BGN": "лв", "HRK": "kn", "RSD": "дин",
  "UAH": "₴", "RUB": "₽", "BYN": "Br", "MDL": "L", "ALL": "L",
  "MKD": "ден", "BAM": "KM", "ISK": "kr", "GEL": "₾", "AMD": "֏",
  "AZN": "₼",
  // African currencies
  "ZAR": "R", "NGN": "₦", "EGP": "E£", "KES": "KSh", "GHS": "₵",
  "MAD": "د.م.", "TND": "د.ت", "DZD": "د.ج", "XOF": "CFA", "XAF": "FCFA",
  "UGX": "USh", "TZS": "TSh", "ETB": "Br", "ZMW": "ZK", "BWP": "P",
  "MUR": "Rs", "NAD": "N$", "MZN": "MT", "AOA": "Kz", "RWF": "FRw",
  "SZL": "E", "LSL": "M", "MWK": "MK", "GMD": "D", "SCR": "Rs",
  // Americas currencies
  "MXN": "MX$", "BRL": "R$", "ARS": "$", "CLP": "CLP$", "COP": "COL$",
  "PEN": "S/", "UYU": "$U", "PYG": "₲", "BOB": "Bs", "VES": "Bs.S",
  "DOP": "RD$", "GTQ": "Q", "CRC": "₡", "PAB": "B/.", "HNL": "L",
  "NIO": "C$", "JMD": "J$", "TTD": "TT$", "BBD": "Bds$", "BSD": "B$",
  "BZD": "BZ$", "GYD": "G$", "SRD": "Sr$", "HTG": "G", "CUP": "₱",
  "AWG": "ƒ", "ANG": "ƒ", "XCD": "EC$", "KYD": "CI$", "BMD": "BD$",
  // Oceania currencies
  "FJD": "FJ$", "PGK": "K", "WST": "WS$", "TOP": "T$", "VUV": "VT",
  "SBD": "SI$", "XPF": "₣"
};

// Comprehensive country code to currency mapping (200+ countries)
export const COUNTRY_TO_CURRENCY = {
  // North America
  "US": "USD", "CA": "CAD", "MX": "MXN",
  // Central America & Caribbean
  "GT": "GTQ", "BZ": "BZD", "SV": "USD", "HN": "HNL", "NI": "NIO",
  "CR": "CRC", "PA": "PAB", "CU": "CUP", "JM": "JMD", "HT": "HTG",
  "DO": "DOP", "PR": "USD", "TT": "TTD", "BB": "BBD", "BS": "BSD",
  "GD": "XCD", "LC": "XCD", "VC": "XCD", "AG": "XCD", "DM": "XCD",
  "KN": "XCD", "AW": "AWG", "CW": "ANG", "SX": "ANG", "KY": "KYD",
  "BM": "BMD", "VI": "USD", "VG": "USD", "AI": "XCD", "MS": "XCD",
  // South America
  "BR": "BRL", "AR": "ARS", "CL": "CLP", "CO": "COP", "PE": "PEN",
  "VE": "VES", "EC": "USD", "BO": "BOB", "PY": "PYG", "UY": "UYU",
  "GY": "GYD", "SR": "SRD", "GF": "EUR", "FK": "FKP",
  // Western Europe
  "GB": "GBP", "UK": "GBP", "IE": "EUR", "FR": "EUR", "DE": "EUR",
  "NL": "EUR", "BE": "EUR", "LU": "EUR", "CH": "CHF", "AT": "EUR",
  "LI": "CHF", "MC": "EUR", "AD": "EUR", "SM": "EUR", "VA": "EUR",
  // Northern Europe
  "NO": "NOK", "SE": "SEK", "DK": "DKK", "FI": "EUR", "IS": "ISK",
  "EE": "EUR", "LV": "EUR", "LT": "EUR",
  // Southern Europe
  "ES": "EUR", "PT": "EUR", "IT": "EUR", "GR": "EUR", "MT": "EUR",
  "CY": "EUR", "HR": "EUR", "SI": "EUR", "BA": "BAM", "RS": "RSD",
  "ME": "EUR", "MK": "MKD", "AL": "ALL", "XK": "EUR",
  // Eastern Europe
  "PL": "PLN", "CZ": "CZK", "SK": "EUR", "HU": "HUF", "RO": "RON",
  "BG": "BGN", "UA": "UAH", "BY": "BYN", "MD": "MDL", "RU": "RUB",
  // Caucasus & Central Asia
  "GE": "GEL", "AM": "AMD", "AZ": "AZN", "KZ": "KZT", "UZ": "UZS",
  "TM": "TMT", "KG": "KGS", "TJ": "TJS",
  // Middle East
  "TR": "TRY", "IL": "ILS", "PS": "ILS", "JO": "JOD", "LB": "LBP",
  "SY": "SYP", "IQ": "IQD", "IR": "IRR", "SA": "SAR", "AE": "AED",
  "QA": "QAR", "BH": "BHD", "KW": "KWD", "OM": "OMR", "YE": "YER",
  // South Asia
  "IN": "INR", "PK": "PKR", "BD": "BDT", "LK": "LKR", "NP": "NPR",
  "BT": "BTN", "MV": "MVR", "AF": "AFN",
  // Southeast Asia
  "TH": "THB", "VN": "VND", "MY": "MYR", "SG": "SGD", "ID": "IDR",
  "PH": "PHP", "MM": "MMK", "KH": "KHR", "LA": "LAK", "BN": "BND",
  "TL": "USD",
  // East Asia
  "CN": "CNY", "JP": "JPY", "KR": "KRW", "KP": "KPW", "MN": "MNT",
  "TW": "TWD", "HK": "HKD", "MO": "MOP",
  // Oceania
  "AU": "AUD", "NZ": "NZD", "FJ": "FJD", "PG": "PGK", "WS": "WST",
  "TO": "TOP", "VU": "VUV", "SB": "SBD", "NC": "XPF", "PF": "XPF",
  "GU": "USD", "AS": "USD", "MP": "USD", "FM": "USD", "MH": "USD",
  "PW": "USD", "KI": "AUD", "NR": "AUD", "TV": "AUD",
  // North Africa
  "EG": "EGP", "LY": "LYD", "TN": "TND", "DZ": "DZD", "MA": "MAD",
  "EH": "MAD", "SD": "SDG", "SS": "SSP",
  // West Africa
  "NG": "NGN", "GH": "GHS", "CI": "XOF", "SN": "XOF", "ML": "XOF",
  "BF": "XOF", "NE": "XOF", "TG": "XOF", "BJ": "XOF", "GW": "XOF",
  "GM": "GMD", "GN": "GNF", "SL": "SLL", "LR": "LRD", "CV": "CVE",
  "MR": "MRU",
  // Central Africa
  "CM": "XAF", "CF": "XAF", "TD": "XAF", "CG": "XAF", "GA": "XAF",
  "GQ": "XAF", "CD": "CDF", "AO": "AOA", "ST": "STN",
  // East Africa
  "KE": "KES", "TZ": "TZS", "UG": "UGX", "RW": "RWF", "BI": "BIF",
  "ET": "ETB", "ER": "ERN", "DJ": "DJF", "SO": "SOS", "SC": "SCR",
  "MU": "MUR", "MG": "MGA", "KM": "KMF", "YT": "EUR", "RE": "EUR",
  // Southern Africa
  "ZA": "ZAR", "NA": "NAD", "BW": "BWP", "ZW": "ZWL", "ZM": "ZMW",
  "MW": "MWK", "MZ": "MZN", "SZ": "SZL", "LS": "LSL"
};

// Convert price from source currency to target currency
export const convertPrice = (amount, fromCurrency = 'USD', toCurrency = 'USD', liveRates = null) => {
  if (!amount || fromCurrency === toCurrency) {
    return { amount, symbol: CURRENCY_SYMBOLS[toCurrency] || '$' };
  }
  
  let fromRate, toRate;
  
  // Use live rates if available (rates are in "1 USD = X currency" format)
  if (liveRates && liveRates[fromCurrency] && liveRates[toCurrency]) {
    // Convert from source to USD, then to target
    fromRate = 1 / liveRates[fromCurrency]; // How much USD for 1 source
    toRate = 1 / liveRates[toCurrency]; // How much USD for 1 target
  } else {
    // Fallback to static rates (already in "1 currency = X USD" format)
    fromRate = CURRENCY_RATES[fromCurrency] || 1;
    toRate = CURRENCY_RATES[toCurrency] || 1;
  }
  
  // Convert from source currency to USD, then to target currency
  const usdAmount = amount * fromRate;
  const convertedAmount = usdAmount / toRate;
  
  return {
    amount: Math.round(convertedAmount * 100) / 100,
    symbol: CURRENCY_SYMBOLS[toCurrency] || '$'
  };
};

// Cache for live exchange rates
let _liveRatesCache = null;
let _liveRatesFetchedAt = null;

// Fetch live exchange rates from API
export const fetchLiveRates = async (apiUrl) => {
  // Return cached rates if less than 1 hour old
  if (_liveRatesCache && _liveRatesFetchedAt && (Date.now() - _liveRatesFetchedAt < 3600000)) {
    return _liveRatesCache;
  }
  
  try {
    const response = await fetch(`${apiUrl}/api/currency/rates`);
    if (response.ok) {
      const data = await response.json();
      if (data.rates) {
        _liveRatesCache = data.rates;
        _liveRatesFetchedAt = Date.now();
        console.log(`Using ${data.source} exchange rates`);
        return _liveRatesCache;
      }
    }
  } catch (error) {
    console.debug('Using static exchange rates');
  }
  return null;
};

// Get cached live rates
export const getLiveRates = () => _liveRatesCache;

// Format price with currency symbol (auto-converts to user's local currency)
export const formatPrice = (amount, currency = 'USD', userCurrency = null) => {
  if (userCurrency && userCurrency.code && userCurrency.code !== currency) {
    const converted = convertPrice(amount, currency, userCurrency.code, _liveRatesCache);
    // Format number based on currency (some need no decimals)
    const noDecimalCurrencies = ['JPY', 'KRW', 'VND', 'IDR', 'CLP'];
    const formattedAmount = noDecimalCurrencies.includes(userCurrency.code)
      ? Math.round(converted.amount).toLocaleString()
      : converted.amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return `${converted.symbol}${formattedAmount}`;
  }
  const symbol = CURRENCY_SYMBOLS[currency] || '$';
  const noDecimalCurrencies = ['JPY', 'KRW', 'VND', 'IDR', 'CLP'];
  const formattedAmount = noDecimalCurrencies.includes(currency)
    ? Math.round(amount || 0).toLocaleString()
    : (amount || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return `${symbol}${formattedAmount}`;
};

// Get currency info from country code (client-side fallback)
export const getCurrencyForCountry = (countryCode) => {
  const currency = COUNTRY_TO_CURRENCY[countryCode] || 'USD';
  return {
    code: currency,
    symbol: CURRENCY_SYMBOLS[currency] || '$',
    country: countryCode
  };
};

// Format date/time in user's local timezone
export const formatLocalDateTime = (dateString, options = {}) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const defaultOptions = {
    dateStyle: 'medium',
    timeStyle: 'short',
    ...options
  };
  
  return date.toLocaleString(undefined, defaultOptions);
};

// Format date only in user's local timezone
export const formatLocalDate = (dateString, options = {}) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const defaultOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...options
  };
  
  return date.toLocaleDateString(undefined, defaultOptions);
};

// Format time only in user's local timezone
export const formatLocalTime = (dateString, options = {}) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const defaultOptions = {
    hour: '2-digit',
    minute: '2-digit',
    ...options
  };
  
  return date.toLocaleTimeString(undefined, defaultOptions);
};

// Get relative time (e.g., "2 hours ago", "3 days ago")
export const formatRelativeTime = (dateString) => {
  if (!dateString) return '';
  
  const date = new Date(dateString);
  const now = new Date();
  const diffMs = now - date;
  const diffSecs = Math.floor(diffMs / 1000);
  const diffMins = Math.floor(diffSecs / 60);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);
  
  if (diffSecs < 60) return 'Just now';
  if (diffMins < 60) return `${diffMins} minute${diffMins > 1 ? 's' : ''} ago`;
  if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
  if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;
  
  return formatLocalDate(dateString);
};

// Demo images for listings without images
export const DEMO_IMAGES = [
  "https://images.unsplash.com/photo-1707849401033-3fe7fdd26e75?w=400&q=80",
  "https://images.unsplash.com/photo-1757946718516-fddeb8d3ed9b?w=400&q=80",
  "https://images.unsplash.com/photo-1631984564919-1f6b2313a71c?w=400&q=80",
  "https://images.unsplash.com/photo-1612186285542-4881d153ac04?w=400&q=80"
];
